// utils
import _ from 'lodash';
import { codeGeneretor } from 'app/utils';

const TEMPLATE_NAME = 'PAD_MODEL_CREATOR_VISIT';

const initialState = () => ({
  screenData: []
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_ADD`: {
      const newData = action.payload;
      const padModelVisit = {
        code: codeGeneretor(),
        ...newData.data
      };

      const screenData = [...state.screenData, padModelVisit];

      return {
        ...state,
        screenData
      };
    }

    case `${TEMPLATE_NAME}_EDIT`: {
      const newData = action.payload;
      const padModelVisitEdited = { ...newData.data };

      const screenData = _.cloneDeep(state.screenData);

      const indexScreen = screenData.findIndex(
        padVisit => padVisit.code === padModelVisitEdited.code
      );
      screenData.splice(indexScreen, 1, padModelVisitEdited);

      return {
        ...state,
        screenData
      };
    }

    case `${TEMPLATE_NAME}_REMOVE`: {
      const newData = action.payload;
      const padModelVisit = { ...newData.data };

      const screenData = _.cloneDeep(state.screenData).filter(
        padVisit => padVisit.code !== padModelVisit.code
      );

      return {
        ...state,
        screenData
      };
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
